import React from "react";
import LabelHowToSection from "../Home/LabelHowToSection.jsx";

const LabelPage = () => <LabelHowToSection />;

export default LabelPage;
